var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "820px",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.shows ? _c('v-card', _vm._b({}, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', [_vm.isCreate ? _c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("공지사항 등록")]) : _c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("공지사항 수정")])]), _c('v-card-text', [_c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "subject", $$v);
      },
      expression: "form.subject"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-datetime-field', {
    attrs: {
      "label": "생성일",
      "type": "date",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.createdAt,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "createdAt", $$v);
      },
      expression: "form.createdAt"
    }
  })], 1)], 1), _c('file-chips-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "첨부파일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.files,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "files", $$v);
      },
      expression: "form.files"
    }
  }), _c('div', {
    staticClass: "caption mt-4 mb-1"
  }, [_vm._v("내용")]), _c('naver-smarteditor', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c('v-card-actions', [_c('v-switch', {
    staticClass: "ma-0 py-0 px-4",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.form.isNotice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isNotice", $$v);
      },
      expression: "form.isNotice"
    }
  }, [_c('span', {
    staticClass: "subtitle-2",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("상단고정")])]), _c('v-spacer'), _c('v-btn', _vm._b({
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("취소")]), _c('v-btn', _vm._b({
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("저장")])], 1), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "light": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "width": "5",
      "size": "100",
      "color": "primary"
    }
  })], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }